import styled from 'styled-components';
import { DiscountRibbon } from 'components/ProductTile/ProductTile.styles';

export const ProductDetailsContainer = styled.div`
  display: flex;
  margin-top: 3%;
  margin-bottom: 100px;
  ${({ theme }) => theme.breakpoints.down('sm')} {
    flex-direction: column;
    > div {
      width: 100%;
    }
  }
  justify-content: space-between;
`;

export const ImageContainer = styled.div`
  width: 45%;
  padding: 0% 3% 0% 0%;
  box-sizing: content-box;
`;

export const DisclaimerText = styled.div`
  margin-top: 1rem;
  font-size: 0.9rem;
  > p {
    margin: 0px;
  }
`;

export const DetailsContainer = styled.div<{
  $width?: string;
  $isSubscription?: boolean;
}>`
  width: ${({ $width }) => ($width ? $width : '50%')};
  padding: ${({ $isSubscription }) => ($isSubscription ? '0% 3% 0% 0%' : '0')};
`;

export const Separator = styled.div`
  margin: 10px 0;
  margin-left: 30px; // to align with radio button
  border-top: 3px solid ${({ theme }) => theme.palette.grey13};
  width: 40px;
`;

export const Name = styled.div`
  font-weight: 500;
  font-size: 2.2rem;
  line-height: 44px;
  color: rgba(23, 23, 23, 1);
`;

export const Sku = styled.div`
  font-weight: 400;
  font-size: 1rem;
  margin-top: 5px;
  line-height: 20px;
`;

export const PriceContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 10px;
  gap: 10px;
`;

// export const Price = styled.div<{ shouldStrikeOff?: boolean }>`
//   font-weight: ${({ shouldStrikeOff }) => (shouldStrikeOff ? 400 : 500)};
//   font-size: ${({ shouldStrikeOff }) =>
//     shouldStrikeOff ? '1.3rem' : '1.5rem'};
//   color: ${({ shouldStrikeOff }) =>
//     shouldStrikeOff ? 'rgba(0, 0, 0, 0.63)' : 'rgba(0, 0, 0, 1)'};
//   text-decoration: ${({ shouldStrikeOff }) =>
//     shouldStrikeOff ? 'line-through' : 'none'};
//   line-height: 32px;
// `;

export const TaxText = styled.div`
  font-size: 0.8rem;
  margin-left: 10px;
`;
export const Price = styled.div<{ $shouldStrikeOff?: boolean }>`
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 32px;
  color: rgba(0, 0, 0, 1);

  ${({ $shouldStrikeOff }) =>
    $shouldStrikeOff &&
    `
            text-decoration: line-through;
            color: rgba(103, 103, 103, 0.5);
            font-weight: 400;
            font-size: 1.3rem;
        `}
`;

export const DiscountedPrice = styled.div`
  font-weight: 500;
  font-size: 1.7rem;
`;

export const DiscountPercentage = styled.div`
  color: #388e3c;
  margin-left: 5px;
  font-weight: 500;
`;

export const LanguageVariants = styled.div`
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* border: 1px solid red; */
  width: 40%;
`;

export const ReplenishSection = styled.div`
  margin-top: 20px;
  padding: 2%;
  background: white;
  border-radius: ${({ theme }) => theme.borderRadius};
`;

export const ReplenishSwitch = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;
export const Label = styled.span`
  font-weight: 500;
  font-size: 1.1rem;
`;
export const OffPercent = styled.span`
  font-weight: 400;
  font-size: 1.1rem;
  color: green;
  margin-left: 3px;
`;

export const AddToCartSection = styled.div`
  margin-top: 20px;
  display: flex;
  align-items: center;
`;

export const CartActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const QuantityWrapper = styled.div``;

export const ButtonWrapper = styled.div`
  margin-left: 5px;
  width: 100%;
`;

export const Favourite = styled.div`
  width: 20%;
  display: flex;
  margin-left: 10px;
`;

export const Title = styled.div`
  padding: 5px;
  margin-top: 20px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  font-weight: 500;
  font-size: 1.2rem;
  width: fit-content;
`;

export const Description = styled.div`
  padding: 5px 5px 5px 5px;
`;

export const ExpirationDate = styled.div`
  font-size: 0.9rem;
  font-weight: 500;
  > span {
    font-weight: 400;
  }
`;

export const ProductPdfListItem = styled.li`
  margin-bottom: 10px;
  list-style-type: none;
`;

export const PdfLink = styled.a`
  color: rgba(32, 154, 214, 1);
  text-decoration: none;
`;

export const Accordian = styled.div`
  margin-top: 10px;
  padding: 0px 10px;
  color: rgba(0, 0, 0, 0.63);
`;

export const DiscountLabel = styled.div`
  margin-top: 20px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.green};
`;

export const Discount = styled.div`
  margin-left: 1%;
`;

export const DiscountDescription = styled.div`
  color: rgba(0, 0, 0, 0.63);
  font-size: 0.9rem;
  line-height: 20px;
  font-weight: 400;
`;

export const DiscountHeader = styled(DiscountDescription)`
  color: ${({ theme }) => theme.palette.green};
  font-weight: 500;
  font-size: 1rem;
  margin-bottom: 10px;
  line-height: 1.3;
`;

export const DiscountItem = styled(DiscountDescription)`
  margin-bottom: 10px;
  padding: 10px 14px;
  background: ${({ theme }) => theme.palette.grey5};
  border-radius: 8px;
  border-left: 4px solid ${({ theme }) => theme.palette.primary};
  color: rgba(0, 0, 0, 0.87);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  font-size: 0.9rem;
`;

export const DiscountNote = styled(DiscountDescription)`
  font-style: italic;
  font-size: 0.8rem;
  margin-top: 12px;
  line-height: 1.4;
`;

export const PromoDescription = styled.div`
  p {
    margin-top: 0;
  }
  margin-left: 20px;
  line-height: 1.5;
`;

export const Dimensions = styled.div`
  margin-top: 10px;
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.63);
  line-height: 20px;
  font-weight: 500;
  margin-left: 1.2em;
`;

export const FlashSaleTimer = styled.div`
  color: #cd071e;
  padding: 4px 30px 3px 10px;
  margin-top: 10px;
  display: inline-block;
  min-width: 200px;
`;

export const FlashSaleBanner = styled.div`
  color: #fff;
  background: rgba(212, 63, 88, 1);
  padding: 5px 10px 5px 10px;
  margin-top: 10px;
  display: inline-block;
  align-self: center;
`;

const redGradient = `
  background: rgb(255, 78, 78);
  background: linear-gradient(
    125deg,
    rgba(255, 78, 78, 1) 0%,
    rgba(255, 0, 0, 1) 100%
  );`;

const orangeGradient = `
  background: rgb(255, 180, 78);
  background: linear-gradient(
    125deg,
    rgba(255, 180, 78, 1) 0%,
    rgba(255, 169, 0, 1) 100%
  );`;

const defaultGradient = `
  background: rgb(0, 212, 4);
  background: linear-gradient(
    125deg,
    rgba(0, 212, 4, 1) 0%,
    rgba(0, 177, 13, 1) 100%
  );`;

export const getProgressBarGradient = (progress: number) => {
  if (progress > 75) {
    return redGradient;
  } else if (progress > 50) {
    return orangeGradient;
  } else {
    return defaultGradient;
  }
};

export const ProgressBarStyle = styled.div<{ progress: number }>`
  ${({ progress }) => getProgressBarGradient(progress)}

  color: white;
  text-align: center;
  border-radius: 10px;
  height: 10px;
  line-height: 20px;
  transition: width 0.5s ease-in-out;
  width: ${({ progress }) => `${progress}%`};
`;
export const ProgressBarContainer = styled.div`
  width: 100%;
  border-radius: 10px;
  background-color: rgba(196, 196, 196, 0.5);
  margin-top: 3px;
  padding: 2px;
`;

export const ProgressBarWrapper = styled.div`
  width: 100%;
  color: black;
`;

export const ProgressPercentage = styled.div`
  margin-top: 5px;
`;

export const FlashsaleWrapper = styled.div`
  width: 10%;
  background-color: white;
`;

export const FlashsaleFlex = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CouponContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 10px 0 0 0;
`;
export const CouponRibbon = styled(DiscountRibbon)`
  position: relative;
  width: 60px;
  margin: unset;
  background: green;

  &::after {
    border-right: 13px solid #f2f2f2;
    z-index: 1;
  }
`;

export const CouponDescription = styled.div`
  color: green;
  user-select: none;

  // removes the margin from coupon detail component without modifying the original component
  div {
    margin-left: unset;
  }
`;

export const FlashSaleContainer = styled.div`
  display: flex;
  align-items: start;
  gap: 20px;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

export const InputLabel = styled.div`
  font-weight: 500;
  color: gray;
  text-align: center;
`;

export const RedeemContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: 10px;
`;

export const RedeemPoints = styled.div<{ wide?: boolean }>`
  display: flex;
  align-items: center;
  font-size: 1.1rem;
`;

export const RedeemPlusContainer = styled.div`
  text-align: center;
`;

export const RedeemCheckboxContainer = styled.div`
  padding-top: 15px;
  width: fit-content;
`;
export const AgreementContainer = styled.div`
  padding: 20px;
  margin-top: 50%;
  padding: 20px;
`;

export const ReviewAlertModalBody = styled.div`
  margin-top: 50%;

  padding: 20px;
  font-weight: 500;
  line-height: 24px;
`;

export const ReviewAlertModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  padding: 0px 20px 20px 20px;
  > button {
    margin-left: 5px;
  }
`;

export const DisclaimerListItem = styled.li`
  margin-top: 5px;
`;

export const DropdownLabel = styled.div`
  color: ${({ theme }) => theme.palette.grey63};
  font-size: 0.8rem;
`;

export const SubscriptionTitle = styled.div`
  margin-bottom: 10px;
  font-size: 1rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.63);
`;

export const SubscriptionSubTitle = styled.span``;

export const SubscriptionOptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const SubscriptionOption = styled.div<{ $isActive: boolean }>`
  border-radius: 5px;
  padding: 5px;
  > div > div:nth-child(2) {
    font-weight: ${({ $isActive }) => ($isActive ? 500 : 'normal')};
    font-size: 1rem;
  }
`;

export const SubscriptionDropdownWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;

  > div {
    white-space: nowrap;
  }
`;

export const LinkWrapper = styled.span`
  > a {
    color: ${({ theme }) => theme.palette.primary};
    text-decoration: none;
  }
`;

export const SubscriptionDiscountContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20%;
  padding: 25px 0px;
  max-height: 70vh;
`;

export const SubscriptionDiscountHeader = styled.div`
  font-weight: 500;
  font-size: 1.3rem;
  color: rgba(0, 0, 0, 0.63);
  text-align: center;
`;

export const SubscriptionDiscountBody = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, auto));
  gap: 16px;
  padding: 10px 25px;
  overflow-y: scroll;
`;

export const SubscriptionDiscountFooter = styled.div`
  margin-top: 10px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.63);
  display: flex;
  justify-content: center;
  gap: 10px;
`;

export const Card = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0px;
`;

export const CardTitle = styled.div`
  font-weight: 600;
  margin-bottom: 20px;
`;

export const CardBody = styled.div``;

export const CardBodyItem = styled.div<{ isSelected: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  width: 100%;
  border-radius: 5px;
  cursor: pointer;
  &:hover {
    background: ${({ theme }) => theme.palette.grey13};
  }
  padding: 10px 20px;
  box-sizing: border-box;
  font-weight: ${({ isSelected }) => (isSelected ? 500 : 400)};
  background: ${({ isSelected, theme }) =>
    isSelected ? '#e2fbe8' : 'transparent'};
`;

export const SubscriptionFreq = styled.div`
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.63);
`;

export const SubscriptionDiscount = styled.div`
  font-weight: 600;
  font-size: 1rem;
  color: #388e3c;
`;

export const Line = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.palette.grey13};
  margin: 8px 0;
`;

export const DiscountBox = styled.div`
  margin-top: 5px;
  font-weight: 500;
  color: #005780;
  background: #e6f7ff;
  padding: 5px 10px;
  border-radius: 30px;
  width: fit-content;
  font-size: 0.8rem;
`;

/* Subscription Plan Modal — redesigned */

export const SubPlanContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 32px;
  max-height: 80vh;
  overflow-y: auto;
`;

export const SubPlanHeader = styled.h2`
  font-weight: 600;
  font-size: 1.25rem;
  color: ${({ theme }) => theme.palette.ink.darkest};
  text-align: center;
  margin: 0;
`;

export const SubPlanSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const SubPlanSectionLabel = styled.span`
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: ${({ theme }) => theme.palette.grey50};
`;

export const SubPlanQuantityRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const SubPlanQuantityPill = styled.button<{ isActive: boolean }>`
  min-width: 40px;
  height: 40px;
  padding: 0 14px;
  border-radius: 20px;
  border: 1px solid
    ${({ isActive, theme }) =>
      isActive ? theme.palette.primary : theme.palette.grey12};
  background: ${({ isActive, theme }) =>
    isActive ? theme.palette.primarySubtle : 'transparent'};
  color: ${({ isActive, theme }) =>
    isActive ? theme.palette.primary : theme.palette.grey70};
  font-weight: ${({ isActive }) => (isActive ? 700 : 500)};
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    border-color: ${({ theme }) => theme.palette.primary};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.palette.primary};
    outline-offset: 2px;
  }
`;

export const SubPlanFrequencyList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const SubPlanFrequencyCard = styled.div<{ isSelected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-radius: 10px;
  border: 1px solid
    ${({ isSelected, theme }) =>
      isSelected ? theme.palette.primary : theme.palette.grey8};
  background: ${({ isSelected, theme }) =>
    isSelected ? theme.palette.primarySubtle : theme.palette.surface.backgroundAlt};
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    border-color: ${({ isSelected, theme }) =>
      isSelected ? theme.palette.primary : theme.palette.grey23};
    background: ${({ isSelected, theme }) =>
      isSelected ? theme.palette.primarySubtle : theme.palette.surface.backgroundAlt};
  }
`;

export const SubPlanFreqCardLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const SubPlanFreqRadio = styled.div<{ isSelected: boolean }>`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 1px solid
    ${({ isSelected, theme }) =>
      isSelected ? theme.palette.primary : theme.palette.sky.lighter};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.palette.primary};
  flex-shrink: 0;
`;

export const SubPlanFreqLabel = styled.span`
  font-size: 0.95rem;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.grey80};
`;

export const SubPlanFreqCardRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
`;

export const SubPlanFreqDiscount = styled.span`
  font-weight: 700;
  font-size: 0.9rem;
  color: ${({ theme }) => theme.palette.green};
  background: ${({ theme }) => theme.palette.successGreenBg};
  padding: 2px 8px;
  border-radius: 12px;
`;

export const SubPlanFreqPricing = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.8rem;
`;

export const SubPlanOriginalPrice = styled.span`
  text-decoration: line-through;
  color: ${({ theme }) => theme.palette.grey40};
`;

export const SubPlanDiscountedPrice = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme.palette.grey80};
`;

export const SubPlanFooter = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  padding-top: 8px;
  border-top: 1px solid ${({ theme }) => theme.palette.grey6};
`;
